import { Component } from '@theme/component';

/**
 * A component that makes the filters toggle button sticky at the bottom
 * when the product grid is in view.
 */
class FiltersStickyComponent extends Component {
  #observer;

  connectedCallback() {
    super.connectedCallback();

    const targetSelector = this.getAttribute('target-selector') || 'results-list';

    const onFilterUpdate = () => {
      setTimeout(() => observeTarget(), 100);
    };

    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // The button should be visible only when the product grid is in the viewport.
          const isVisible = entry.isIntersecting;

          if (isVisible) {
            this.classList.add('is-active');
          } else {
            this.classList.remove('is-active');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px'
      }
    );

    const observeTarget = () => {
      const target = document.querySelector(targetSelector) || document.querySelector('.product-grid');

      if (target) {
        this.#observer.disconnect();
        this.#observer.observe(target);

        // Manual check for initial state or updates
        const rect = target.getBoundingClientRect();
        // isVisible if any part of the target is within the viewport
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
          this.classList.add('is-active');
        } else {
          this.classList.remove('is-active');
        }
      }
    };

    observeTarget();

    // Re-observe when filters are updated, as the target element might be replaced/morphed
    document.addEventListener('filter:update', onFilterUpdate);

    // Keep a reference to the bound function for removal
    this._observeTarget = observeTarget;
    this._onFilterUpdate = onFilterUpdate;
    this._handleDialogClose = (event) => {
      if (event.target.id === 'filters-drawer') {
        setTimeout(() => observeTarget(), 100);
      }
    };

    // Also check visibility when the filters drawer closes
    document.addEventListener('dialog:close', this._handleDialogClose);
  }

  updatedCallback() {
    super.updatedCallback();
    if (this._observeTarget) {
      this._observeTarget();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#observer) {
      this.#observer.disconnect();
    }
    if (this._onFilterUpdate) {
      document.removeEventListener('filter:update', this._onFilterUpdate);
    }
    if (this._handleDialogClose) {
      document.removeEventListener('dialog:close', this._handleDialogClose);
    }
  }
}

if (!customElements.get('bbd-filters-sticky')) {
  customElements.define('bbd-filters-sticky', FiltersStickyComponent);
}
